<script lang="ts" setup>
import { removeLegacyFeedbackTab } from '~/utils/feedbackUrl';

const route = useRoute();
const { selectedSizeId } = storeToRefs(useCatalogStore());

const query = computed(() => {
  const routeQuery = removeLegacyFeedbackTab(route.query);

  return selectedSizeId.value ? { ...routeQuery, offer_id: selectedSizeId.value } : routeQuery;
});

const { questions } = storeToRefs(useFeedbackStore());
const { questionsTotalCountPluralized } = useProductFeedback();
const isHydrated = useHydratedFlag();
const hasQuestions = computed(() => isHydrated.value && questions.value.length > 0);
</script>

<template>
  <NuxtLink
    :to="{ query, hash: '#questions' }"
    class="product-page__questions-link"
  >
    <div class="flex flex-col gap-2">
      <div class="flex items-center gap-1">
        <SvgoDialog
          :class="hasQuestions ? 'text-black' : 'text-black-40'"
          :font-controlled="false"
          class="size-3"
          filled
        />

        <span v-if="!hasQuestions">Задать </span>
      </div>

      <span v-if="!hasQuestions"> вопрос</span>
    </div>

    <template v-if="hasQuestions">{{ questionsTotalCountPluralized }}</template>
  </NuxtLink>
</template>

<style lang="scss" scoped>
.product-page {
  &__questions-link {
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: fit-content;
    padding: 8px;
    border: 1px solid $black-10;
    border-radius: 8px;
    background-color: $white;
    color: $blue;
    font-size: $text-xs;
    text-decoration: none;
    transition: all 0.3s;

    &:hover {
      color: $label-violet;
    }
  }
}
</style>
